/**
 * CSV built in the browser from numbers already on the page, for reports that
 * have no server-side export.
 */

export type CsvCell = string | number | null | undefined;

/**
 * One cell, quoted when it has to be. A text cell starting with = + - @ is
 * prefixed with an apostrophe: region names come from member profiles, and a
 * spreadsheet would otherwise run one shaped like a formula.
 */
export function csvCell(value: CsvCell): string {
  if (value === null || value === undefined) return "";
  if (typeof value === "number") return String(value);
  const text = /^[=+\-@\t\r]/.test(value) ? `'${value}` : value;
  return /[",\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

export function toCsv(rows: CsvCell[][]): string {
  return rows.map((row) => row.map(csvCell).join(",")).join("\r\n");
}

/** Saves the text as a file. The byte-order mark makes Excel read it as UTF-8. */
export function downloadCsv(filename: string, csv: string): void {
  const blob = new Blob(["﻿", csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

/** `YYYY-MM-DD` in the browser's own day, for file names and date columns. */
export function localDate(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}
